import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { getEventFromStorage } from "../services/token";

function ChatPage() {
    const { t } = useTranslation();
    
    useEffect(() => {
        let eventId = getEventFromStorage();
        window.location.href = `${process.env.REACT_APP_BACKEND_BASE_URL}/it/events/${eventId}/platform/chat_channels`;
        return () => {}
    }, [])

    return (
        <div>
            <h1>{ t('common:redirect_to_chat') }</h1>
        </div>
    );
}

export default ChatPage;